/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import * as API from "../API/api";
import { MyToggleButton } from "./helpercomponents/CustomGridCells/MyToggleButton"
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from "../forms/helpercomponents/CustomGridCells/DateCell";
import { LookupCell } from "../forms/helpercomponents/CustomGridCells/LookupCell";
import { ImageCell } from "./helpercomponents/CustomGridCells/ImageCell";
import EditForm from "./helpercomponents/editForm";
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, MODULE, FILEURL, DELIVERYSTATUSENUM, SOCKET_EVENTS, SOCKET_ACTION, LOGEVENT, UPCOMING_EVENTS_MONTHS, ROLETYPE, TEMPLATENAME, TOAST_TYPES } from "../constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteErrorDialogBox from "./helpercomponents/alert/DeleteErrorDialogBox";
import { MenuCommandCell } from "./helpercomponents/CustomGridCells/MenuCommandCell ";
import { TimeCell } from "./helpercomponents/CustomGridCells/TimeCell";
import { collectionMenuModel } from "./helpercomponents/contextMenu/menus/collectionMenuModel";
import { UserPreference } from "../../modules/userPreference/UserPreference";
import { utility } from "../utility/utilityProvider";
import { ArrayCell } from "./helpercomponents/CustomGridCells/ArrayCell";
import { CheckboxCell } from "./helpercomponents/CustomGridCells/CheckBoxCell";
import { HrefCell, HyperLinkCell } from "./helpercomponents/CustomGridCells/HrefCell";
import { useTranslation } from "../../locale/useTranslation";
import BackRoundButton from "./helpercomponents/buttons/BackRoundButton";
import AddRoundButton from "./helpercomponents/buttons/AddRoundButton";
import RefreshButton from "./helpercomponents/buttons/RefreshButton";
import PreferenceRoundButton from "./helpercomponents/buttons/PreferenceRoundButton";
import { EnumCell, SIDEnumCell } from "./helpercomponents/CustomGridCells/EnumCell";
import RoundButton from "./helpercomponents/buttons/RoundButton";
import { EditPageHeader } from "../../components/EditPageHeader";
import { PlatformCell, arrayEnumCell, daysCell } from "./helpercomponents/CustomGridCells/PlatformCell";
import MyStatusCell from "../../components/MyStatusCell";
import MediaEpisodeHistory from "../../modules/Planning/MediaEpisodeHistory";
import { IconCell } from "./helpercomponents/CustomGridCells/IconCell";
import Preview from "../../modules/platformLayout/tv/homePage/components/Preview";
import socket from "../socket/socket";
import { getter } from "@progress/kendo-data-query";
import ActionButton from "./helpercomponents/buttons/ActionButton";
import { Loader } from "./helpercomponents/Loader";
import MediaFastSegmentationPopup from "../../modules/Segment/MediaFastSegmentationPopup";
import { colorCell } from "./helpercomponents/CustomGridCells/ColorCell";
import BossDialog from "../../components/BossDialog";
import { MediaFilterTemplate } from "../../modules/Planning/MediaFilterTemplate";
import DigitalSignMobileCollection from "../../modules/DigitalSign/mobileView/DigitalSignMobileCollection";
import { MultiLangArrayCell } from "./helpercomponents/CustomGridCells/MultiLangArrayCell";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ContentArrayImageCell } from "./helpercomponents/CustomGridCells/ContentArrayImageCell";
import { TextWithIconCell } from "./helpercomponents/CustomGridCells/TextWithIconCell";
import SMInsightsForm from "../../modules/SocialMedia/SMInsightsForm";
import SMSharePostForm from "../../modules/SocialMedia/SMSharePostForm";
import castTypeCell from "./helpercomponents/CustomGridCells/CastTypeCell";
import { CustomCell } from "./helpercomponents/CustomGridCells/CustomCell";
import IngestForm from "../../modules/IngestionTemplate/IngestForm";
import CreateRecursiveSlotPopup from "../../modules/Planning/PlanningWithSlot/CreateRecursiveSlotPopup";
import { ContextMenu } from 'primereact/contextmenu';
import { TransmissionTypeStatusCell } from "../../components/TransmissionTypeStatusCell";
import ToastNotification from "../../components/ToastNotification";
//entityname is table name
// filterable = false
// sortable = false
// pageable = false
// take = 10
//showEdit = true
//showTitle = true

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

export const Collection = (props) => {

  //possible props
  let page_take = props.page_take ?? 50;
  let showAdd = props.showAdd ?? true;
  let showBack = props.showBack ?? true;
  let showImport = props.showImport ?? false;
  let showExport = props.showExport ?? true;
  let showArchive = props.showArchive ?? true;
  let showCommandCell = props.showCommandCell ?? true;
  let showEdit = props.showEdit ?? true;
  let showDelete = props.showDelete ?? true;
  let showTitle = props.showTitle ?? true;
  let gridRowRender = props.gridRowRender;
  let CustomEditForm = props.customEditForm ?? EditForm;
  let filterable = props.filterable ?? false;
  let sortable = props.sortable ?? true;
  let isPageable = props.isPageable ?? true;
  let wherestatement = props.wherestatement ?? [];
  let andWhereStatement = props.andWhereStatement ?? [];
  let sort = props.sort ?? { SID: 1 };
  let customColumns = props.customColumns ?? [];
  let openNewEditForm = props.openNewEditForm ?? false;
  let myTitle = props.title ?? "";
  let myMenuModel = props.menuModel ?? collectionMenuModel;
  let entityName = props.entityname;
  let showPreferenceButton = props.showPreferenceButton ?? true;
  let hideArchiveProps = props.hideArchive ?? false;
  let showFilterTemplate = props.showFilterTemplate ?? false;
  let enableMutliSelect = props.enableMutliSelect ?? false;
  let module = props?.module;
  let showLogs = props.showLogs ?? true;
  let doLoad = props.isLoading ?? true;
  let showSyncMaMAsset = props.showSyncMaMAsset ?? false;
  let showLangDropdown = props.showLangDropdown ?? false;
  let isTieredMenu = props.isTieredMenu ?? false;
  let showContextMenu = props.showContextMenu ?? false;

  // Get User Data from Local Storage
  const userData = utility.getValue(LOCALSTORAGE_KEY.userData);

  //Add this for media management preference column
  const preferenceColumnENntityName = props.preferenceEntityName && props.preferenceEntityName.length > 0 ? props.preferenceEntityName : entityName;
  // example custome columns[]
  const [gridData, setGridData] = useState([]);
  const [total, setTotal] = useState(1);
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState({ SID: 1 });
  const [warningDialog, setWarningDialog] = useState(false);
  const [deleteError, setDeleteError] = useState(false);
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isNoRecords, setIsNoRecords] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [dataColumns, setDataColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [showArchived, setShowArchived] = useState(false);
  const [hideArchive] = useState(hideArchiveProps);
  const [showHistory, setShowHistory] = useState(false);
  const [showPreviewCollection, setShowPreviewCollection] = useState(false);
  const [filterDataItem, setFilterDataItem] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const [filterTemplate, setFilterTemplate] = useState([]);
  const [fastSegmentationPopupOpen, setFastSegmentationPopupOpen] = useState(false);
  const fastSegmentationItemRef = useRef({})
  const initialSort = { field: Object.keys(sort)[0], dir: sort[Object.keys(sort)[0]] == 1 ? "asc" : "desc" }
  const [gridSort, setGridSort] = useState([initialSort]);
  const [filterPopupOpen, setFilterPopupOpen] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);
  const [upcomingEventsData, setUpcomingEventsData] = useState({ Month: { _id: null, Description: 'All' }, Year: { _id: null, Description: 'All' } });
  const [showInsightPopup, setShowInsightPopup] = useState(false);
  const [budgets, setBudgets] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [clients, setclients] = useState([]);
  const [channels, setChannels] = useState([]);
  const [smFilterData, setSMFilterData] = useState({ budget: { _id: null, description: 'All' }, agency: { _id: null, Name: 'All' }, client: { _id: null, Name: 'All' }, channel: { _id: null, adType: 'All' } });
  const [showPopupSMSharePost, setShowPopupSMSharePost] = useState({ show: false, item: {}, type: null });
  const [showImportForm, setShowImportForm] = useState(false);
  const [showRecursiveSlotPopup, setShowRecursiveSlotPopup] = useState(false);
  const recursiveSlotItemRef = useRef(null);
  const onCreateRecursiveSlot = (item) => {
    recursiveSlotItemRef.current = item;
    setShowRecursiveSlotPopup(true);
  };

  const selectedItemsRef = useRef([]);
  const setSelectedItem = (items) => {
    selectedItemsRef.current = items;
  }

  //reset password
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [resetPasswordDataItem, setResetPasswordDataItem] = useState({
    newPassword: "",
    ConfirmPassword: ""
  })
  const resetPasswordUserRef = useRef();
  const setResetPasswordUserRef = (data) => {
    resetPasswordUserRef.current = data
  }

  const historyRef = useRef();
  const setHistoryRef = (data) => {
    historyRef.current = data
  }

  const exportMECRef = useRef();
  const setExportMECRef = (data) => {
    exportMECRef.current = data
  }

  const exportMMCRef = useRef();
  const setExportMMCRef = (data) => {
    exportMMCRef.current = data
  }

  const previewRef = useRef();
  const setPreviewRef = (data) => {
    previewRef.current = data
  }

  const gridRef = useRef(null);
  const menuRef = useRef(null);

  const [page, setPage] = useState({
    skip: 0,
    take: page_take,
  });

  const loc = useLocation();
  const lang = useTranslation();

  const urlParams = new URLSearchParams(location?.search ?? "");
  const Company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const companyId = urlParams?.get('companyId');
  const companyPlanID = urlParams?.get('companyId');
  const paramQuery = {
    curPage: parseInt(urlParams.get('page')) || 1,
    index: parseInt(urlParams.get('index')) || 0
  }

  if (entityName == ENTITYNAME.Users && companyId) {
    wherestatement = [...wherestatement, ['Company._id', '=', companyId]];
  }

  if (entityName == ENTITYNAME.DigitalSignCompanyPlans && companyPlanID) {
    wherestatement = [...wherestatement, ['company_id', '=', companyPlanID]];
  }

  let href = loc.state ? loc.state.href : false;
  if (href) {
    wherestatement = loc.state.wherestatement;
  }

  const [isMobile, setIsMobile] = useState(false);

  //LANGUAGE CHANGES
  const selectedLanguageRef = useRef();
  const [selectedLanguage, _setSelectedLanguage] = useState({});
  const setSelectedLanguage = async (data, load = false) => {
    selectedLanguageRef.current = data;
    _setSelectedLanguage(data);
  }

  const languageRef = useRef();
  const [languages, _setLanguages] = useState([]);
  const setLanguages = async (data, load = false) => {
    languageRef.current = data;
    _setLanguages(data);
  }

  useEffect(() => {
    // Function to calculate screen orientation and size
    const updateScreenType = () => {
      const isPortrait = window.innerHeight > window.innerWidth;
      setIsMobile(isPortrait); // Set true for portrait mode
    };

    // Initial check
    updateScreenType();

    // Add event listener for window resize
    window.addEventListener('resize', updateScreenType);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', updateScreenType);
  }, []);

  useEffect(() => {
    loadcombo();
    setShowArchived(false);
    doLoad ? setIsLoading(true) : setIsLoading(false);
    setPage({ skip: (paramQuery.curPage - 1) * page_take, take: page_take });
    loaddata({ per_page: page_take, current_page: paramQuery.curPage }, wherestatement, andWhereStatement, '', false, filterTemplate);
  }, [props.entityname, props.gridData, props.title, props.wherestatement]);

  const onSearch = (e) => {
    e.preventDefault();
    let text = e.target.value;
    setSearchText(text);
  };

  // Search 
  useEffect(() => {
    if (searchText == null) return;
    let sortEvent = gridSort[0] ?? initialSort;
    if (searchText != "") {
      const timeOut = setTimeout(() => {
        setIsLoading(true);
        loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
      }, 700);
      return () => clearTimeout(timeOut);
    } else {
      setIsLoading(true);
      setPage({ skip: (paramQuery.curPage - 1) * page_take, take: page_take });
      loaddata({ per_page: page_take, current_page: paramQuery.curPage, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
    }
  }, [searchText]);

  useEffect(() => {
    if (gridRef.current && paramQuery.index >= 0) {
      let updateIndex = paramQuery.index > page_take ? paramQuery.index - ((paramQuery.curPage - 1) * page_take) : paramQuery.index;
      const gridElement = gridRef.current.element || gridRef.current.wrapper || gridRef.current;
      const contentArea = gridElement.querySelector('.k-grid-content');
      if (!contentArea) return;
      const rows = contentArea.querySelectorAll('tr');
      if (updateIndex < rows.length) {
        const targetRow = rows[updateIndex];
        const rowOffsetTop = targetRow.offsetTop;
        const contentAreaHeight = contentArea.clientHeight;
        const scrollPosition = rowOffsetTop - contentAreaHeight / 2 + targetRow.clientHeight / 2;
        contentArea.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      }
    }
  }, [paramQuery.index, gridData]);

  const loadcombo = async () => {

    let languageRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 }, query: ['Archive', '=', false] });
    setLanguages(languageRes.data);
    setSelectedLanguage(Company.Language);
    const monthRes = Object.keys(UPCOMING_EVENTS_MONTHS).map(x => ({
      _id: UPCOMING_EVENTS_MONTHS[x],
      Description: x
    }));
    monthRes.unshift({ _id: null, Description: "All" });
    setMonths(monthRes);
    generateYearOptions();
    const budgetRes = await API.getDataLookup(ENTITYNAME.SM_Budgets);
    budgetRes.data.unshift({ _id: null, description: 'All' });
    setBudgets(budgetRes.data);
    const agencyRes = await API.getDataLookup(ENTITYNAME.Agency);
    agencyRes.data.unshift({ _id: null, Name: 'All' });
    setAgencies(agencyRes.data);
    const clientRes = await API.getDataLookup(ENTITYNAME.Client);
    clientRes.data.unshift({ _id: null, Name: 'All' });
    setclients(clientRes.data);
    const channelRes = await API.getDataLookup(ENTITYNAME.SM_Channels);
    channelRes.data.unshift({ _id: null, adType: 'All' })
    setChannels(channelRes.data);
  }

  const onResetPasswordchange = (e) => {
    setResetPasswordDataItem({ ...resetPasswordDataItem, [e.target.name]: e.target.value });
  }

  const isValidForResetPassword = () => {
    if (resetPasswordDataItem.newPassword == undefined || resetPasswordDataItem.newPassword == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_new_password_error_message });
      return false;
    }
    if (resetPasswordDataItem.ConfirmPassword == undefined || resetPasswordDataItem.ConfirmPassword == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_confirm_password_users_error_message });
      return false;
    }
    if (resetPasswordDataItem.newPassword !== resetPasswordDataItem.ConfirmPassword) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.confirm_password_do_not_match_error_message });
      return false;
    }
    return true;
  }
  const handleResetPassword = async () => {
    if (isValidForResetPassword()) {
      var res = await API.saveData(ENTITYNAME.Users, { _id: resetPasswordUserRef.current._id, password: resetPasswordDataItem.newPassword });
      console.log(res);
      if (res.success) {
        setShowResetPassword(false);
        setResetPasswordDataItem({});
      } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }
    }
  }

  const onResetPassword = (userData) => {
    setShowResetPassword(true);
    setResetPasswordUserRef(userData);
    console.log(resetPasswordUserRef)
  }

  const onKillUserSession = (userData) => {
    delete userData["Module"];
    console.log(userData);
    socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.KILL_USER_SESSION, module: MODULE.ALL, data: userData })
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${userData.name} session has been killed successfully` });
  }

  const enterEdit = (item = {}) => {
    console.log("onEnterEdit");
    if (openNewEditForm === false || (entityName == ENTITYNAME.Tournament && item.SID == 0)) {
      setOpenForm(true);
      setEditItem(item);
    } else if (entityName == ENTITYNAME.SM_Budgets || entityName == ENTITYNAME.Tournament) {
      let param = item?._id ?? 0;
      let current_page = page.skip / page.take + 1;
      let prevPath = item.prevPath ?? 0;
      let state = {
        copy: item.copy ? true : false,
        quickEdit: item.quickEdit ? true : false,
        prevPath: loc.pathname + `?page=${current_page + prevPath}`,
        paths: [loc.pathname],
        pagination: `?page=${current_page + prevPath}`
      }
      navigate(`${param}?page=${current_page + prevPath}`, { state: state });
    } else {
      let param = item.SID;
      let current_page = page.skip / page.take + 1;
      let prevPath = item.prevPath ?? 0;
      let state = {
        copy: item.copy ? true : false,
        quickEdit: item.quickEdit ? true : false,
        prevPath: loc.pathname + `?page=${current_page + prevPath}`,
        paths: [loc.pathname],
        pagination: `?page=${current_page + prevPath}`
      }
      navigate(`${param}?page=${current_page + prevPath}`, { state: state });
    }
  };

  const history = (item) => {
    console.log('history');
    setHistoryRef(item);
    setShowHistory(item.history);
  };

  const exportMECXML = (item) => {
    console.log(item);
    setExportMECRef(item);
    exportMECData(item)
  };

  const exportMECData = async (exportDataItem) => {
    var res = await API.getAmazonMECXML(exportDataItem);
    console.log('res.success');
    if (res.success) {
      window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_exported_export_template_message });
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };

  const exportMMCXML = (item) => {
    console.log(item);
    setExportMMCRef(item);
    exportMMCData(item)
  };

  const exportMMCData = async (exportDataItem) => {
    var res = await API.getAmazonMMCXML(exportDataItem);
    console.log('res.success');
    if (res.success) {
      window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_exported_export_template_message });
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };

  const ottPackageDeliverySchedule = (item) => {
    onOttPackageDeliverySchedule(item)
  };

  const onOttPackageDeliverySchedule = async (item) => {
    const saveData = {
      MediaEpisode: { _id: item._id, Title: item.Title, AssetId: item.AssetId, MediaCategory: item.MediaCategory.Description, EpisodeNumber: item.EpisodeNumber },
      User: { _id: utility.getValue(LOCALSTORAGE_KEY.user_id) },
      DeliveryStatus: DELIVERYSTATUSENUM[0],
      TimeStamp: Date.now(),
      MetaDataChecklistResult: '',
      AssetChecklistResult: '',
      AmazonDeliveryGroup: { _id: "", Description: "" },
      Archive: false,
    };
    console.log(saveData)
    var res = await API.saveData(ENTITYNAME.OttPackageDeliverySchedule, saveData);
    console.log(res);
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }
    if (!res.success) return;
    navigate(-1);
  };

  //publish for OTT
  const onPublish = async (itemID) => {
    console.log('publish');
    const res = await API.onPublishSeason(itemID);
    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
      return;
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }

  };

  const handleNavigate = (item) => {
    if (item?.Module) {
      window.open(item.path, "MyTargetWindowName");
    } else {
      navigate(`${item.path}`, { state: item });
    }
  }

  //onSubmit from EDIRFORM
  const handleSubmit = async (dataItem, dataToSave) => {
    console.log("handleSUbmit");
    //if datatosave is null then dataitem is datasave
    dataToSave = dataToSave == null ? dataItem : dataToSave;

    let isDuplicate = await utility.checkDuplicate(props.entityname, dataToSave);

    if (!isDuplicate) {
      setOpenForm(true);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.entry_already_exist_try_with_different_values_collection_error_message });
      return;
    }

    let res = await API.saveData(props.entityname, dataToSave);
    console.log(res);
    if (dataItem?.IsDefault) {
      await API.setAsDefault(entityName, dataItem?._id)
    }
    if (res.success) {
      if (showLogs) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: module, data: res.data, message: res.message };
        API.SaveLogs(logData);
      }
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }
    socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
    utility.deleteLocalStorageItem(props.entityname)
    //to load grid with new data
    loaddata({ per_page: page_take, current_page: 1 }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
    setOpenForm(false);
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const handleDelete = async (dataItem) => {
    console.log(dataItem);
    onConfirmDelete(dataItem)
  };

  const handleArchive = async (dataItem) => {
    console.log("Here");
    if (entityName == ENTITYNAME.Series || entityName == ENTITYNAME.Season) {
      var resArchiveUpdated = await API.onChangeArchiveInSeriesSeason({
        _id: dataItem._id,
        archive: !dataItem.Archive,
        entityName: entityName
      })
    } else {
      var resArchiveUpdated = await API.saveData(entityName, {
        ...dataItem,
        Archive: !dataItem.Archive
      })
    }

    if (resArchiveUpdated.success) {
      console.log(`Archive is been updated to ${!dataItem.Archive}`);
      if (module) {
        let logData = { event: !dataItem.Archive ? LOGEVENT.ARCHIVE : LOGEVENT.UNARCHIVE, module: module, data: { ...dataItem, Archive: !dataItem.Archive }, message: resArchiveUpdated.message };
        API.SaveLogs(logData);
      }
      let sortEvent = gridSort[0] ?? initialSort;
      let current_page = page.skip / page.take + 1;
      loaddata({ per_page: page_take, current_page: !dataItem.Archive ? current_page : 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
      socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
      utility.deleteLocalStorageItem(entityName);
    } else {
      console.log(resArchiveUpdated.message);
    }
  }

  const onCloseUserPrefence = () => {
    let sortEvent = gridSort[0] ?? initialSort;
    loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
    setShowPreferences(!showPreferences);

  }

  const setAsDefault = async (data) => {

    var setAsDefaultRes = await API.setAsDefault(entityName, data._id);
    if (setAsDefaultRes.success) {
      let sortEvent = gridSort[0] ?? initialSort;
      loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
      socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
      utility.deleteLocalStorageItem(entityName);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: setAsDefaultRes.message });
    }

  }

  const preview = (props) => {
    setPreviewRef(props)
    setShowPreviewCollection(true);
  }

  const handleForceUnlock = (dataItem) => {
    onConfirmDelete(dataItem);
    let logData = { event: LOGEVENT.UNLOCK_PLANNING_SCHEDULE, module: MODULE.PLANNING_LOCK_SCHEDULE, data: dataItem, message: LOGEVENT.UNLOCK_PLANNING_SCHEDULE };
    API.SaveLogs(logData);
  }

  const onCopyURL = (dataItem) => {
    if (!dataItem || !dataItem?.ImageUrl) {
      return;
    }
    navigator.clipboard.writeText(dataItem?.ImageUrl).then(() => {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "URL copied successfully!" });
    }).catch((err) => {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: err.message });
    });
  };

  const onPreview = (dataItem) => {
    setSelectedItem(dataItem)
    setShowPreview(true);
  }

  const handleInsight = (dataItem) => {
    setSelectedItem(dataItem)
    setShowInsightPopup(true);
  }

  const onSMSharePostMeta = (item) => {
    setShowPopupSMSharePost({ show: true, item: item, type: "meta" });
  }
  const onSMSharePostLinkedIn = (item) => {
    setShowPopupSMSharePost({ show: true, item: item, type: "linkedin" });
  }
  const onSMSharePostGoogle = (item) => {
    setShowPopupSMSharePost({ show: true, item: item, type: "google" });
  }
  const onSMSharePostYouTube = (item) => {
    setShowPopupSMSharePost({ show: true, item: item, type: "youtube" });
  }
  const onSMSharePostSnapChat = (item) => {
    setShowPopupSMSharePost({ show: true, item: item, type: "snapchat" });
  }

  const MyCheckBoxCell = (props) => {
    const value = props?.dataItem?.[props.field];
    return (
      <td style={{ marginLeft: "10px" }}>
        {value === 1 ? 'Yes' : 'No'}
      </td>
    );
  };

  //Edit Row
  const MyCommandCell = (props) => (

    <MenuCommandCell
      {...props}
      showLogs={showLogs}
      publish={onPublish}
      history={history}
      enterEdit={enterEdit}
      cancelEdit={handleCancelEdit}
      onSubmit={handleSubmit}
      item={editItem}
      dataColumns={dataColumns}
      onDelete={handleDelete}
      onArchive={handleArchive}
      showEdit={showEdit}
      showDelete={showDelete}
      toNavigate={handleNavigate}
      myMenuModel={myMenuModel}
      module={module}
      openNewEditForm={openNewEditForm}
      onResetPassword={onResetPassword}
      onKillUserSession={onKillUserSession}
      setAsDefault={setAsDefault}
      exportMECXML={exportMECXML}
      exportMMCXML={exportMMCXML}
      preview={preview}
      ottPackageDeliverySchedule={ottPackageDeliverySchedule}
      onForceUnlock={handleForceUnlock}
      onFastSegmentation={handleFastSegmentation}
      onPreview={onPreview}
      onCopyURL={onCopyURL}
      onInsight={handleInsight}
      isTieredMenu={isTieredMenu}
      onSMSharePostMeta={onSMSharePostMeta}
      onSMSharePostLinkedIn={onSMSharePostLinkedIn}
      onSMSharePostGoogle={onSMSharePostGoogle}
      onSMSharePostYouTube={onSMSharePostYouTube}
      onSMSharePostSnapChat={onSMSharePostSnapChat}
      onCreateRecursiveSlot={onCreateRecursiveSlot}
    />
  );

  const handleFastSegmentation = (item) => {
    fastSegmentationItemRef.current = item
    setFastSegmentationPopupOpen(true)
  }

  const MyCustomToggleButton = (props) => (
    <MyToggleButton
      {...props}
      entityName={entityName}
      size={"small"}
      onGridDataUpdate={updateGridDataByIndex}
    />
  );

  const updateGridDataByIndex = (index, field, value) => {
    const updated = [...gridData];
    if (updated[index]) {
      updated[index] = { ...updated[index], [field]: value };
      setGridData(updated);
    }
  };

  const MyDatalookupCell = (props) => (
    <LookupCell {...props} dataColumns={dataColumns} />
  );

  const Mystatuscell = (props) => {
    const { dataItem } = props;

    let title = "";
    let tileBackColor = "";

    if (entityName === ENTITYNAME.PaymentProvider) {
      title = dataItem?.isActive ? "Active" : "Deactive";
      tileBackColor = dataItem?.isActive ? "#63aa43" : "#E72929";
    } else if (entityName === ENTITYNAME.OttProvider) {
      title = dataItem?.IsActive ? "Active" : "Deactive";
      tileBackColor = dataItem?.IsActive ? "#63aa43" : "#E72929";
    } else {
      title = dataItem?.CurrentStatus ?? "";
      tileBackColor = "#72eda9";
    }

    return (
      <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} />
    );
  };

  const MyMultiLangArrayCell = (props) => (
    <MultiLangArrayCell selectedLang={selectedLanguageRef.current} {...props} />
  )

  const loaddata = async (pagination, wherestatement, andWhereStatement, searchText, archive, filters) => {

    if (props.gridColumns) {
      setDataColumns(props.gridColumns);
      setGridData(props.gridData);
      setIsLoading(false);
    } else {
      try {
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(preferenceColumnENntityName, currentUserId);
        let finalSort = pagination.direction ? { [pagination.orderby ?? 'SID']: pagination.direction == 'asc' ? 1 : -1 } : sort;
        
        // Filter user has channel rights
        if (props.entityname == ENTITYNAME.Format && userData?.RoleType?.ID == ROLETYPE.User) {
          wherestatement = [...wherestatement, ["Channel._id", "in", userData?.Channels ?? []]];
        }
        
        let json = await API.getEntitiesWithSearch(
          props.entityname,
          { query: wherestatement, page: pagination.current_page, perPage: pagination.per_page, archive: archive, sort: finalSort },
          columns,
          searchText,
          filters
        );
        setGridData(json?.data ?? []);
        setTotal(json?.pagination?.total);
        //if custmoe colum is coming from compemnent level then no need  a column from Server API
        customColumns.length > 0
          ? setDataColumns(customColumns)
          : setDataColumns(columns);

        // console.log(columns)
        setIsLoading(false);
      } catch (error) {
        console.log("error", error);
        setIsLoading(false);
        setIsNoRecords(true);
      }
    }
  };

  const handleErrorDialogClose = () => {
    setDeleteError(!deleteError);
    setDeleteErrorMessage("");
  }
  const errorHandler = (message) => {
    setWarningDialog(!warningDialog);
    setDeleteError(true);
    setDeleteErrorMessage(message);
  }

  const onConfirmDelete = async (dataItem) => {
    let res = { success: false, message: "" };
    switch (entityName) {
      case ENTITYNAME.DAI_CHANNELS:
        let user = utility.getValue(LOCALSTORAGE_KEY.userData);
        if (user?.RoleType?.ID == ROLETYPE.User) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.dai_channel_delete_error_messgae });
          return;
        }
        res = await API.daiChannelDelete(dataItem._id);
        break;
      default:
        await API.deleteData(props.entityname, dataItem.SID);
    }
    if (!res.success) {
      errorHandler(res.message);
      return;
    }
    let current_page = page.skip / page.take + 1;
    let sortEvent = gridSort[0] ?? initialSort;
    loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, '', showArchived, filterTemplate);
    socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
    utility.deleteLocalStorageItem(props.entityname);
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
  }

  const pageChange = async (e) => {
    let current_page = e.page.skip / e.page.take + 1;
    let sortEvent = gridSort[0] ?? initialSort;
    const url = new URL(window.location);
    url.searchParams.set('page', current_page);
    url.searchParams.set('index', 0);
    window.history.pushState({}, '', url);
    await loaddata({ per_page: e.page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
    setPage(e.page);
    cancelSelectedItem();
  };

  const onArchiveClick = () => {
    setShowArchived(!showArchived);
    let sortEvent = gridSort[0] ?? initialSort;
    if (!showArchived) {
      loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, true, filterTemplate);
    } else {
      let current_page = page.skip / page.take + 1;
      loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, false, filterTemplate);
    }
    cancelSelectedItem();
  }

  const refreshCollection = () => {
    setIsLoading(true);
    let current_page = page.skip / page.take + 1;
    loaddata({ per_page: page.take, current_page: current_page, orderby: "SID", direction: "asc" }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
    setGridSort([initialSort]);
  }

  const onSortChange = (e) => {
    setGridSort(e.sort)
    let sortEvent = e.sort[0] ?? sort;
    let current_page = page.skip / page.take + 1;
    loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
  }

  const downloadExcel = async () => {
    let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
    let columns = await API.getFormData(preferenceColumnENntityName, currentUserId);
    let dataRes = await API.getEntitiesWithSearch(
      props.entityname,
      { per_page: null, current_page: null, query: wherestatement, archive: showArchived },
      columns,
      searchText,
      filterTemplate
    );
    if (dataRes?.success && dataRes?.data?.length == 0) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_error_message });
      return;
    }

    let res = await API.exportGridExcel(dataRes?.data, dataColumns, preferenceColumnENntityName);
    if (res.success) {
      window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const toGetFilteredData = (data) => {

    setIsLoading(true);
    let sortEvent = gridSort[0] ?? initialSort
    let finalData = {
      ...data,
      ReleaseYear: data.ReleaseYear == "" ? null : parseInt(data.ReleaseYear),
    }
    setFilterDataItem(finalData);

    //NEED TO CREATE WHERESTATEMENT HERE
    let finalFilterQuery = {};

    if (Object.keys(finalData).length != 0) {

      let genresFilter = finalData.Genres.length != 0 ? [['Genres._id', 'in', finalData.Genres.map((item) => item._id)]] : [];
      let isLiveFilter = finalData.isLive ? ["IsLive", '=', true] : ["IsLive", '!=', true];
      let releaseYearFilter = finalData.ReleaseYear != null ? [["ReleaseDate", ">=", new Date(`${finalData.ReleaseYear}-01-01`).getTime()], ["ReleaseDate", "<=", new Date(`${finalData.ReleaseYear}-12-31`).getTime()]] : []

      finalFilterQuery = [...genresFilter, ...releaseYearFilter, isLiveFilter];
    }
    setFilterTemplate(finalFilterQuery);
    loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, finalFilterQuery)
  }

  const onSelectionChange = (event) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState: selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });
    setSelectedState(newSelectedState);

    let selectedIds = Object.keys(newSelectedState);
    let tempSelected = [];

    selectedIds.map((value) => {
      if (newSelectedState[value]) {
        let filter = gridData.find((obj) => obj._id == value);
        tempSelected.push(filter);
      }
    });

    setSelectedItem(tempSelected);
  };


  const onHeaderSelectionChange = (event) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    event.dataItems.forEach((item) => {
      newSelectedState[idGetter(item)] = checked;
    });
    setSelectedState(newSelectedState);

    var selectedIds = Object.keys(newSelectedState);
    var tempSelected = [];

    if (checked) {
      selectedIds.map((value) => {
        if (newSelectedState[value]) {
          var filtered = gridData.find((obj) => obj._id == value);
          tempSelected.push(filtered);
        }
      });
    }
    setSelectedItem(tempSelected);
  };

  const onArchiveButtonClick = async () => {
    if (selectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
      return;
    }
    for (let i = 0; i < selectedItemsRef.current.length; i++) {
      const item = selectedItemsRef.current[i];
      await handleArchive(item);
    }
    cancelSelectedItem();
  }

  const onEnterEdit = () => {
    enterEdit({ SID: 0 });
    cancelSelectedItem();
  }

  const cancelSelectedItem = () => {
    setSelectedItem([]);
    setSelectedState({});
  }

  let timeOut;
  const handleColumnResize = (event) => {
    let lockedCol = event.columns.filter((item) => item?.locked).length ?? 1;
    try {
      if (event.index == 0) return;
      if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;
      let column = dataColumns[event.index - lockedCol];
      let payload = {
        entityName: column?.entityName,
        name: column?.name,
        width: event.newWidth
      };
      clearTimeout(timeOut);
      timeOut = setTimeout(() => {
        API.updateUserPreferenceColumnWidth(payload);
      }, 700);
    } catch (error) {
      console.error("Error handling column resize:", error);
    }
  };

  //SYNC MAM ASSET
  const syncMAMAsset = async () => {

    if (gridData.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return;
    }

    let res = await API.syncMAMDataWithMediaEpisode();
    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const yearOptions = [{ _id: null, Description: 'All' }];
    for (let year = currentYear - 3; year <= currentYear + 5; year++) {
      yearOptions.push({ _id: year, Description: year.toString() });
    }
    setYears(yearOptions);
  };

  const onFilterChangeUpcomingEvents = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...upcomingEventsData, [name]: value };
    setUpcomingEventsData(updatedData);

    const year = updatedData.Year?._id;
    const month = updatedData.Month?._id;

    let newWhereStatement = [];

    if (year && month) {
      const paddedMonth = month.toString().padStart(2, '0');
      const startOfMonth = moment(`${year}-${paddedMonth}-01`).startOf('month').valueOf();
      const endOfMonth = moment(`${year}-${paddedMonth}-01`).endOf('month').valueOf();

      newWhereStatement = [['StartDate', '<=', endOfMonth], ['LaunchDate', '>=', startOfMonth]];
    } else if (year && !month) {
      const startOfYear = moment(`${year}-01-01`).startOf('day').valueOf();
      const endOfYear = moment(`${year}-12-31`).endOf('day').valueOf();

      newWhereStatement = [['StartDate', '<=', endOfYear], ['LaunchDate', '>=', startOfYear]];
    }
    loaddata({ per_page: 10, current_page: 1 }, newWhereStatement, andWhereStatement, searchText, showArchived);
  };

  const onSMFilterChange = (e) => {
    const { name, value } = e.target;

    const updatedData = { ...smFilterData, [name]: value };
    setSMFilterData(updatedData);

    const newWhereStatement = [];

    if (updatedData.budget._id) { newWhereStatement.push(['budget._id', '=', updatedData.budget._id]) }

    if (updatedData.agency._id) { newWhereStatement.push(['agency._id', '=', updatedData.agency._id]) }

    if (updatedData.client._id) { newWhereStatement.push(['client._id', '=', updatedData.client._id]) }

    if (updatedData.channel._id) { newWhereStatement.push(['channel._id', '=', updatedData.channel._id]) }

    loaddata({ per_page: 10, current_page: 1 }, newWhereStatement, andWhereStatement, searchText, showArchived);
  };

  const onDownloadTemplate = async () => {
    const fileName = entityName === ENTITYNAME.Agency ? TEMPLATENAME.AgencyTemplate : entityName === ENTITYNAME.Client ? TEMPLATENAME.ClientTemplate : '';
    if (fileName == '') {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.file_not_found_label });
      return;
    }
    try {
      let filePath = FILEURL().BASEURL + 'downloadTemplate/' + fileName;
      window.open(filePath);
    } catch (error) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.downloading_template_error_message });
    }
  }

  const onImportClick = () => {
    if (entityName === ENTITYNAME.Agency || entityName === ENTITYNAME.Client) {
      setShowImportForm(true);
    } else {
      navigate('/home/DataMigration', { state: { mediaCategory: props.mediaCategory } })
    }
  }

  const menuModel = [
    (entityName === ENTITYNAME.Agency || entityName === ENTITYNAME.Client) && {
      label: lang.download_template_label,
      icon: 'pi pi-file',
      command: () => onDownloadTemplate({})
    },
    showImport && {
      label: lang.import_label,
      icon: 'pi pi-upload',
      command: () => onImportClick()
    },
    showExport && {
      label: lang.export_label,
      icon: 'pi pi-download',
      command: () => downloadExcel()
    }
  ].filter(Boolean);

  return (
    <>
      {isMobile && (entityName == ENTITYNAME.Resolution || entityName == ENTITYNAME.DigitalSignPlan || entityName == ENTITYNAME.DigitalSignCompanyPlans || entityName == ENTITYNAME.Instance) ? <DigitalSignMobileCollection entityName={entityName} handleDelete={handleDelete} handleArchive={handleArchive} columns={dataColumns} isLoading={isLoading} gridData={gridData} myTitle={myTitle} showBack={showBack} showAdd={showAdd} onEnterEdit={enterEdit} /> :
        <div>
          {showTitle && (
            <h1 className="page-title txt-color-bludeDark">
              <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
              ></i>
              <span>{myTitle === "" ? props.entityname : myTitle}</span>
            </h1>
          )}
          <div className="flex-container">
            <div className="martb mar">
              {showBack && (
                <BackRoundButton onClick={() => navigate(-1)}></BackRoundButton>
              )}
              {showAdd && (
                <AddRoundButton onClick={onEnterEdit}></AddRoundButton>
              )}
              {/* add context menu */}
              {showContextMenu && <RoundButton icon="ellipsis-v" title={lang.context_menu_label} onClick={(e) => menuRef.current.show(e)} />}
              <ContextMenu
                ref={menuRef}
                model={menuModel}
              />
              {showSyncMaMAsset && (
                <RoundButton
                  icon={"squarespace"}
                  btnColor={"warning"}
                  title={lang.sync_mam_asset_label}
                  onClick={syncMAMAsset}
                />
              )}
              {showArchive && enableMutliSelect && selectedItemsRef.current.length != 0 && (
                <ActionButton title={showArchived ? lang.un_archive_label : lang.archive} name={showArchived ? lang.un_archive_label : lang.archive}
                  onClick={onArchiveButtonClick} />
              )}
            </div>
            {entityName === ENTITYNAME.SM_Campaigns && (
              <div className="d-flex flex-column" style={{ width: '200px', marginTop: "-15px" }}>
                <label className="budget">{lang.budget_label}</label>
                <DropDownList
                  data={budgets}
                  name="budget"
                  dataItemKey="_id"
                  textField="description"
                  onChange={onSMFilterChange}
                  value={smFilterData.budget}
                  style={{ backgroundColor: 'white', height: '32px' }}
                />
              </div>
            )}
            {entityName === ENTITYNAME.SM_Budgets && (
              <>
                <div className="d-flex flex-column mr-2" style={{ width: '160px', marginTop: "-14px" }}>
                  <label className="agency">{lang.agency_label}</label>
                  <DropDownList
                    data={agencies}
                    name="agency"
                    dataItemKey="_id"
                    textField="Name"
                    onChange={onSMFilterChange}
                    value={smFilterData.agency}
                    style={{ backgroundColor: 'white', height: '32px' }}
                  />
                </div>
                <div className="d-flex flex-column" style={{ width: '160px', marginTop: "-14px" }}>
                  <label className="client">{lang.client_label}</label>
                  <DropDownList
                    data={clients}
                    name="client"
                    dataItemKey="_id"
                    textField="Name"
                    onChange={onSMFilterChange}
                    value={smFilterData.client}
                    style={{ backgroundColor: 'white', height: '32px' }}
                  />
                </div>
              </>
            )}
            {entityName === ENTITYNAME.SM_Audience && (
              <div className="d-flex flex-column" style={{ width: '200px', marginTop: "-15px" }}>
                <label className="channel">{lang.channel_label}</label>
                <DropDownList
                  name="channel"
                  textField="adType"
                  dataItemKey="_id"
                  data={channels}
                  value={smFilterData.channel}
                  onChange={onSMFilterChange}
                  style={{ backgroundColor: 'white', height: '32px' }}
                />
              </div>
            )}
            <div className="flex-container-reverse flex-item-auto">
              <div className="input-group input-group w-300 martb" >
                <input
                  type="text"
                  className="form-control shadow-inset-2 pt-0 pb-0"
                  id="searchInput"
                  placeholder={lang.search_button_text}
                  onChange={onSearch}
                  onFocus={(e) => {
                    if (props.setOutSideFocus) {
                      props.setOutSideFocus(true);
                    }
                  }}
                  onBlur={(e) => {
                    if (props.setOutSideFocus) {
                      props.setOutSideFocus(false);
                    }
                  }}
                />
                {showFilterTemplate ?
                  <button title="Advanced Search" style={{ border: "0px", backgroundColor: "white", height: "38px", marginTop: '-1px' }} onClick={() => setFilterPopupOpen(true)} aria-label="Advanced Search">
                    <div className="input-group-append" >
                      <span className="input-group-text" style={{ backgroundColor: isFilterCleared ? "black" : "white" }}>
                        <i style={{ margin: "5px 0px", color: isFilterCleared ? "white" : "black" }} className="fa fa-list" />
                      </span>
                    </div>
                  </button> :
                  <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                      </span>
                    </div>
                  </button>}
              </div>
              {showLangDropdown && <DropDownList
                data={languages}
                style={{ backgroundColor: 'white', width: '200px', height: '38px', margin: '10px' }}
                name="Language"
                textField="Description"
                dataItemKey="_id"
                value={selectedLanguage}
                onChange={(e) => setSelectedLanguage(e.target.value, true)}
              />}
              {showPreferenceButton && <div className="m-1" style={{ paddingTop: "12px" }}>
                <PreferenceRoundButton
                  icon={"gear"}
                  title={lang.preference_button_tooltip}
                  onClick={() => { setShowPreferences(!showPreferences) }}
                />
              </div>}
              <div className="mt-1" style={{ paddingTop: "12px" }}>
                <RefreshButton
                  onClick={refreshCollection}
                />
              </div>
              {showExport && (
                <div className="m-1" style={{ paddingTop: "12px" }}>
                  <RoundButton
                    icon={"download"}
                    btnColor={"info"}
                    style={{ color: 'white' }}
                    title={lang.export_button_tooltip}
                    onClick={downloadExcel}
                  />
                </div>
              )}
              {!hideArchive && <div className="d-inline mt-3 mr-2">
                <input type='checkbox' name='FilteredArchive' checked={showArchived} onClick={onArchiveClick} onChange={() => { }} />  {lang.archive}
              </div>}
              {entityName == ENTITYNAME.OttUpcomingEvents &&
                <>
                  <DropDownList
                    data={months}
                    name='Month'
                    dataItemKey='_id'
                    textField='Description'
                    onChange={onFilterChangeUpcomingEvents}
                    value={upcomingEventsData.Month}
                    style={{ backgroundColor: 'white', width: '200px', height: '38px', margin: '10px' }}
                  />

                  <DropDownList
                    data={years}
                    name='Year'
                    dataItemKey='_id'
                    textField='Description'
                    onChange={onFilterChangeUpcomingEvents}
                    value={upcomingEventsData.Year}
                    style={{ backgroundColor: 'white', width: '200px', height: '38px', margin: '10px' }}
                  />
                </>
              }
            </div>
          </div>
          {isLoading && <Loader />}

          {isNoRecords && <div style={{ margin: "0px 500px" }}><h4><strong>{lang.no_records_found}</strong></h4></div>}
          {!isLoading && !isNoRecords &&
            <Grid
              style={props.gridstyle ?? {
                height: "76vh",
              }}
              ref={gridRef}
              sort={gridSort}
              sortable={sortable}
              onSortChange={onSortChange}
              rowRender={gridRowRender}
              filterable={filterable}
              pageable={isPageable}
              skip={page.skip}
              take={page.take}
              onPageChange={pageChange}
              total={total}
              resizable={true}
              onColumnResize={handleColumnResize}
              data={
                gridData.map((item) => ({
                  ...item,
                  [SELECTED_FIELD]: selectedState[idGetter(item)],
                }))}
              selectedField={SELECTED_FIELD}
              selectable={{
                enabled: enableMutliSelect,
                drag: false,
                cell: false,
                mode: "multiple",
              }}
              dataItemKey={DATA_ITEM_KEY}
              onSelectionChange={onSelectionChange}
              onHeaderSelectionChange={onHeaderSelectionChange}
            >

              {/* Multi Select Checkbox row */}
              {enableMutliSelect && (<GridColumn
                field={SELECTED_FIELD}
                width="50px"
                headerSelectionValue={
                  gridData.findIndex(
                    (item) => !selectedState[idGetter(item)]
                  ) === -1
                }
                locked={true}
                filterable={false}
              />
              )}

              {/* Edit Row */}
              {showCommandCell && (
                <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
              )}

              {/* Rows Loop */}
              {dataColumns.map((column, index) => {
                if (column.type === COLUMNSTYPE.date) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={DateOnlyCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={true}
                    />
                  );
                  // }else if (column.name === COLUMNSTYPE.time) {
                } else if (column.type === COLUMNSTYPE.custom) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={CustomCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={true}
                    />
                  );
                  // }else if (column.name === COLUMNSTYPE.time) {
                } else if (column.type === COLUMNSTYPE.datetime) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={DateCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={true}
                    />
                  );
                  // }else if (column.name === COLUMNSTYPE.time) {
                } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={TimeCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={true}
                    />
                  );
                } else if (column.name === "SID") {
                  return;
                  //we are not returning any value for SID column
                } else if (column.type === COLUMNSTYPE.image) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={(p) => ImageCell({ ...p, title: column.label })}
                      title={column.label}
                      width={column.width ?? 100}
                      sortable={false}
                    />
                  );
                } else if (column.type === COLUMNSTYPE.select) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={MyDatalookupCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.toggle) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={MyCustomToggleButton}
                      title={column.label}
                      width={85}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.checkbox) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={CheckboxCell}
                      title={column.label}
                      width={column.width ?? 80}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.array) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={ArrayCell}
                      title={column.label}
                      width={column.width ?? 200}
                      format={column.format ?? "Description"} //display item in object
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.href) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={HrefCell}
                      title={column.label}
                      width={column.width ?? 200}
                      format={column.format}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.hyperlink) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={HyperLinkCell}
                      title={column.label}
                      width={column.width ?? 200}
                      format={column.format}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.enum) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={EnumCell}
                      title={column.label}
                      width={column.width ?? 200}
                      format={column.format ?? "Description"} //display item in object
                      sortable={true}
                    />
                  );
                } else if (column.type === COLUMNSTYPE.platform) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={PlatformCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.status) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={Mystatuscell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.localdatetime) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={LocalDateTimeColumn}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={true}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.icon) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={IconCell}
                      title={column.label}
                      width={column.width ?? 80}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.arrayenum) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={arrayEnumCell}
                      title={column.label}
                      width={column.width ?? 80}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.color) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={colorCell}
                      title={column.label}
                      width={column.width ?? 80}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.day) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={daysCell}
                      title={column.label}
                      width={column.width ?? 80}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.multiLangCell) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={MyMultiLangArrayCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.textWithIcon) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={TextWithIconCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.imageArrayCell) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={ContentArrayImageCell}
                      title={column.label}
                      width={column.width ?? 350}
                      sortable={false}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.castType) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={castTypeCell}
                      title={column.label}
                      width={column.width ?? 80}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.SIDEnum) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={(props) => SIDEnumCell({ ...props, fk_entityName: column.fk_entityName, fk_field: column.fk_field })}
                      title={column.label}
                      width={column.width ?? 80}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.boolean) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={MyCheckBoxCell}
                      title={column.label}
                      width={column.width ?? 80}
                    />
                  );
                }
                else if (column.type === COLUMNSTYPE.transmissionTypeStatus) {
                  return (
                    <GridColumn
                      key={index}
                      field={column.name}
                      cell={TransmissionTypeStatusCell}
                      title={column.label}
                      width={column.width ?? 200}
                      sortable={false}
                    />
                  );
                }
                else {
                  return (
                    column.type !== COLUMNSTYPE.hidden && (
                      <GridColumn
                        key={index}
                        field={column.name}
                        title={column.label}
                        width={column.width ?? 200}
                        sortable={true}
                      />
                    )
                  );
                }
              })}
            </Grid>}
        </div>
      }

      {openForm && (
        <CustomEditForm
          {...props} //to get other props from customEditForm
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          refresh={refreshCollection}//to refresh the collection when data added
          item={editItem}
          dataColumns={dataColumns}
        />
      )}

      {deleteError &&
        <DeleteErrorDialogBox message={deleteErrorMessage} onClose={handleErrorDialogClose} title={`Error Deleting - ${props.title}`} />}
      {showPreferences && <UserPreference entityName={entityName} preferenceColumnENntityName={props.preferenceEntityName} handleClose={onCloseUserPrefence} />}
      {/* only for user collection */}
      {showResetPassword &&
        <BossDialog
          title={lang.reset_password_label}
          onClose={() => { setShowResetPassword(false); setResetPasswordDataItem({}) }}
          width={"500px"}
        >
          <div className="row">
            <div className="col-12">
              <EditPageHeader onSubmit={handleResetPassword} showTitle={false} onCancel={() => { setShowResetPassword(false); setResetPasswordDataItem({}) }}></EditPageHeader>
              <div className="form-group">
                <label htmlFor="newPassword">{lang.new_password_label}</label>
                <input className="form-control" type="password" name={"newPassword"} onChange={onResetPasswordchange} value={resetPasswordDataItem.newPassword} />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">{lang.confirm_password_label}</label>
                <input className="form-control" type="password" name={"ConfirmPassword"} onChange={onResetPasswordchange} value={resetPasswordDataItem.ConfirmPassword} />
              </div>
            </div>
          </div>
        </BossDialog>}

      {showHistory && <MediaEpisodeHistory selectedData={historyRef.current} closeForm={() => setShowHistory(false)} />}

      {showPreviewCollection && <BossDialog
        title={previewRef.current.isMobile ? lang.mobile_preview_label : lang.tv_preview_label}
        onClose={() => { setShowPreviewCollection(false) }}
        width={previewRef.current.isMobile ? "750px" : "1200px"}
        height={previewRef.current.isMobile ? "580px" : "700px"}
      >
        <div className="row">
          <div className={previewRef.current.isMobile ? "col mt-4" : "col"} style={previewRef.current.isMobile ? { marginLeft: '13%', height: '100%', scale: '0.7', color: 'white' } : { marginTop: '-5px', marginLeft: '4px' }}>
            <div className="row" style={previewRef.current.isMobile ? { display: "flex" } : { display: "block" }}>
              <Preview pageData={previewRef.current} isMobile={previewRef.current.isMobile} ></Preview>
            </div>
          </div>
        </div>
      </BossDialog>}

      {fastSegmentationPopupOpen && <MediaFastSegmentationPopup mediaEpisodeEntity={fastSegmentationItemRef.current} programScheduleEntity={{}} refreshSegments={() => { }} onClose={() => setFastSegmentationPopupOpen(false)} source={'media'} />}
      {filterPopupOpen && <MediaFilterTemplate
        filterDataItem={filterDataItem}
        toGetFilterDataItem={toGetFilteredData}
        isFilterCleared={setIsFilterCleared}
        closeFilterPopup={() => setFilterPopupOpen(false)}
        disableMediaCategory={true}
        mediaCategorySID={props.mediaCategory}
        hideFields={true}
        isNonLinearFileds={false}
        onClear={() => { wherestatement = props.wherestatement; setFilterTemplate([]); }}
        setSelectedTemplate={setSelectedTemplate}
        selectedTemplate={selectedTemplate}
      />}

      {showPreview && <BossDialog
        title={lang.preview_menu}
        onClose={() => setShowPreview(false)}
        width={"22.5vw"}
      >
        <div className="row" style={{ margin: "5px 10px" }}>
          <img src={selectedItemsRef?.current?.ImageUrl} style={{ width: '100%', height: 'auto' }} />
        </div></BossDialog>}
      {showInsightPopup && <SMInsightsForm item={selectedItemsRef?.current} onClose={() => setShowInsightPopup(false)} />}
      {showPopupSMSharePost.show && (<SMSharePostForm item={showPopupSMSharePost.item} type={showPopupSMSharePost.type} onClose={() => setShowPopupSMSharePost({ show: false, item: {}, type: null })} />)}
      {showImportForm && <BossDialog title={lang.import_file_label} onClose={() => { setShowImportForm(false) }} width={"60vw"}>
        <IngestForm onClose={() => { setShowImportForm(false) }} entityName={entityName} onRefresh={refreshCollection} />
      </BossDialog>}
      {showRecursiveSlotPopup && recursiveSlotItemRef.current && (
        <CreateRecursiveSlotPopup
          slot={recursiveSlotItemRef.current}
          onClose={() => {
            setShowRecursiveSlotPopup(false);
            recursiveSlotItemRef.current = null;
          }}
          onSuccess={() => {
            setShowRecursiveSlotPopup(false);
            recursiveSlotItemRef.current = null;
            let sortEvent = gridSort[0] ?? initialSort;
            loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived, filterTemplate);
          }}
        />
      )}
    </>
  );
};